export default __webpack_public_path__ + "static/bmac-btn-8f9b246531e2bbaab0cf0dc5d312235c.png";